import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'components/Button';
import useCallbackRef from 'hooks/useCallbackRef';
import ButtonPanel from './ButtonPanel';
import { useAutoCompletion } from '../AutoCompleteWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
function DirectDownloadLink(_ref) {
  var asset = _ref.asset,
    link = _ref.link,
    autoCompleteEnabled = _ref.autoCompleteEnabled,
    onLoad = _ref.onLoad,
    onComplete = _ref.onComplete;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var onLoadRef = useCallbackRef(onLoad);
  useEffect(function () {
    if (asset) {
      onLoadRef.current();
    }
  }, [asset, onLoadRef]);
  var _useAutoCompletion = useAutoCompletion({
      autoCompleteEnabled: autoCompleteEnabled,
      userContentStatus: asset.userContentStatus,
      onComplete: onComplete
    }),
    markAsCompleted = _useAutoCompletion.markAsCompleted;
  var buttonProps = {
    as: 'a',
    href: link,
    onClick: markAsCompleted
  };
  return /*#__PURE__*/_jsx(ButtonPanel, {
    asset: asset,
    imageButtonProps: buttonProps,
    children: /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({}, buttonProps), {}, {
      variant: "primary",
      icon: "download",
      children: t('actions_download')
    }))
  });
}
export default DirectDownloadLink;